// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"af160ee3","453":"079d4a1d"}[chunkId] + ".chunk.js";
};